<div class="confirmationContainer confirmationContainer--navConfirmation nav-confirmation">
  <div class="modal-close mb-30" *ngIf="data.dialogType === confirmDialogType.LeaveStay">
    <button type="button" (click)="onSelection(confirmResult.Stay)" class="clost-btn">
      <img src="assets/svg/icons/modal-close.svg" />
    </button>
  </div>
  <div class="confirmationContainer__info w-auto">
    <h3 class="confirmationContainer__nav mb-30">
      {{ data.description }}
    </h3>
    <h3 class="confirmationContainer__nav">{{ data.message }}</h3>
  </div>
  <ng-container *ngIf="data.dialogType === confirmDialogType.Ok">
    <ng-container *ngTemplateOutlet="ok"> </ng-container>
  </ng-container>
  <ng-container *ngIf="data.dialogType === confirmDialogType.LeaveStay">
    <ng-container *ngTemplateOutlet="leaveStay"> </ng-container>
  </ng-container>
  <ng-container *ngIf="data.dialogType === confirmDialogType.YesNo">
    <ng-container *ngTemplateOutlet="yesNo"> </ng-container>
  </ng-container>
  <ng-container *ngIf="data.dialogType === confirmDialogType.LogoutHome">
    <ng-container *ngTemplateOutlet="logoutHome"> </ng-container>
  </ng-container>
</div>

<ng-template #ok>
  <div class="confirmationContainer__navigationButtons">
    <button
      mat-raised-button
      type="button"
      (click)="onSelection(confirmResult.Ok)"
      class="navigationButtons__confirm cmn-draft-btn transform-none"
    >
      <span class="material-icons">check</span> Ok
    </button>
  </div>
</ng-template>

<ng-template #leaveStay>
  <div class="confirmationContainer__navigationButtons d-inline-flex">
    <button mat-raised-button type="button" (click)="onSelection(confirmResult.Leave)" class="navigationButtons__confirm cmn-draft-btn">
      <span class="material-icons btn-arw ml-0 mr-10">keyboard_arrow_left</span> Leave this page
    </button>
    <button mat-raised-button type="button" (click)="onSelection(confirmResult.Stay)" class="navigationButtons__cancel cmn-blue-btn">
      Stay on this page <span class="material-icons  btn-arw">keyboard_arrow_right</span>
    </button>
  </div>
</ng-template>

<ng-template #yesNo>
  <div class="confirmationContainer__navigationButtons d-inline-flex">
    <button mat-raised-button type="button" (click)="onSelection(confirmResult.Yes)" class="navigationButtons__confirm cmn-success-btn">
      Yes
    </button>
    <button
      mat-raised-button
      type="button"
      (click)="onSelection(confirmResult.No)"
      class="navigationButtons__cancel cmn-draft-btn min-w160"
    >
      No
    </button>
  </div>
</ng-template>

<ng-template #logoutHome>
  <div class="confirmationContainer__navigationButtons">
    <button mat-raised-button type="button" (click)="onSelection(confirmResult.Logout)" class="navigationButtons__confirm cmn-draft-btn">
      <span class="material-icons">logout</span> Logoff
    </button>
    <button mat-raised-button type="button" (click)="onSelection(confirmResult.Home)" class="navigationButtons__cancel cmn-blue-btn">
      <span class="material-icons">home</span> Home
    </button>
  </div>
</ng-template>
